const Divider = (props) => (
    <div class="rounded bg-dark" style={{ height: props.height }} />
);

export default Divider;